
export const GroupEndpoints = (builder) => ({

  getGroups: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
        sortBy,         // optional: 'GroupName' for dropdown, undefined for list view
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      // Add searchTerm and searchValue only if they are defined and not null
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }
      // Only include sortBy when explicitly requested (e.g. from dropdown)
      if (sortBy !== null && sortBy !== undefined) {
        params.sortBy = sortBy;
      }

      return {
        url: '/common/group-list',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Group'],
  }),


  getGroupById: builder.query({
    query: (id) => ({
      url: `/common/get-GroupById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Group', id }],
  }),

  getCustomerByGroupId: builder.query({
    query: (groupId) => ({
      url: `/common/customers/by-group/${groupId}`,
      method: 'GET',
    }),
    providesTags: ['Group', 'Customer'],
  }),

  getGroupBankDetails: builder.query({
    query: (groupId) => ({
      url: `/common/bank-details/by-group/${groupId}`,
      method: 'GET',
    }),
    providesTags: ['Group', 'Customer'],
  }),

  saveGroup: builder.mutation({
    query: (data) => ({
      url: '/common/save-Group',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Group'],
  }),

  updateGroup: builder.mutation({
    query: ({ data }) => ({
      url: `/common/save-Group`,
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'Group', id },
      'Group'
    ],
  }),

  changeGroupHead: builder.mutation({
    query: (data) => ({
      url: '/common/change-group-head',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Group'],
  }),

  generateGroupCode: builder.mutation({
    query: (data) => ({
      url: '/common/generate-group-code',
      method: 'POST',
      body: data,
    }),
  }),

  checkGroupCode: builder.query({
    query: (code) => ({
      url: `/common/check-group-code/${code}`,
      method: 'GET',
    }),
  }),

  deleteGroup: builder.mutation({
    query: (id) => ({
      url: `/common/delete-Group/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Group'],
  }),


bulkDeleteGroups: builder.mutation({
  query: (body) => ({
    url: "/common/bulk-delete-Group",
    method: "DELETE",
    body,
  }),
}),

mergeAndDeleteGroup: builder.mutation({
  query: (body) => ({
    url: '/common/merge-and-delete-group',
    method: 'POST',
    body,
  }),
  invalidatesTags: ['Group', 'Customer'],
}),

});
